import { pipe } from 'pipe-and-compose';

const prepareForRound = (value: number) => (`${value}e2` as unknown) as number;
const prepareForNumber = (value: number) => `${value}e-2`;

const precisionRound = pipe(
  prepareForRound,
  Math.round,
  prepareForNumber,
  Number,
);

export default precisionRound;
